import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { BlankLayout } from '../../layouts/misc/blank';
import { Grid, Typography } from '@material-ui/core';
import { LargeInteracIcon } from '../../components/icon/vendorIcons';
import { NumericFormat } from 'react-number-format';
import { useQuery } from '../../utils/route';
import { IsValidNumber } from '../../global/util';
import { Stack } from '@mui/material';
import { Loader } from '../../components/loader/loader';

export const InteracLoadingPage: React.FC = observer(() => {
    const [amount, setAmount] = useState<number>(0);
    const q = useQuery();
    useEffect(() => {
        const a = q.get('amount');
        if (a && IsValidNumber(a)) {
            setAmount(Number(a));
        }
    });

    return (
        <BlankLayout showImage={false}>
            <Grid container item xs={12} spacing={3}>
                <Grid item xs={12}>
                    <Typography variant='h5' align='right' gutterBottom>
                        <LargeInteracIcon />
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Stack>
                        <Typography variant='h5' align='center' gutterBottom>
                            Creating <i>Interac</i> e-Transfer® payment request for{' '}
                            <b>
                                <NumericFormat
                                    value={amount}
                                    prefix='$ '
                                    suffix=' CAD'
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    decimalSeparator='.'
                                    fixedDecimalScale
                                    decimalScale={2}
                                />
                            </b>
                            .
                        </Typography>
                        <br />
                        <Typography variant='h5' align='center' gutterBottom>
                            <Loader loading={true} />
                            Please Wait...
                        </Typography>
                        <br />
                        <br />
                        <Typography variant='h5' align='center' gutterBottom>
                            <b>DO NOT CLOSE THIS PAGE</b>
                        </Typography>
                    </Stack>
                </Grid>
            </Grid>
        </BlankLayout>
    );
});
